import { LoadingIndicator } from './common/LoadingIndicator';
import { useTranslation } from '../i18n'; // Assuming i18n is set up

export function LoadingScreen() {
  const { t } = useTranslation();

  // Using a more descriptive message from translation if available, or a default
  const loadingMessage = t('loadingScreen.mainText', 'Loading...');

  return (
    // LoadingIndicator now handles the full screen styling including background
    <LoadingIndicator 
      fullScreen={true} 
      message={loadingMessage} // Pass the main message to LoadingIndicator
    />
    // If you want a sub-message specifically for LoadingScreen that's NOT part of LoadingIndicator:
    // <div className="flex flex-col items-center justify-center h-screen bg-gray-50 dark:bg-gray-900">
    //   <LoadingIndicator message={loadingMessage} />
    //   <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">{subMessage}</p>
    // </div>
    // For this task, the instruction was "Ensure this text is: Clearly visible and well-styled (e.g., text-lg text-gray-600 dark:text-gray-400)"
    // which LoadingIndicator now handles. So, the simpler approach is to let LoadingIndicator manage the text.
  );
}